module.exports = __webpack_public_path__ + "img/delete-bin-2-line.3abf8dec.svg";